import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import axios from "axios";
import ENVIRONMENT from "../../../../environments";
import Welcome from "./ShopifyWelcome";

export default function ShopifyInstall() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const shop = params.get("shop") || localStorage.getItem("shop");
    const hmac = params.get("hmac") || localStorage.getItem("hmac");
    const host = params.get("host") || localStorage.getItem("host");
    const timestamp = params.get("timestamp") || localStorage.getItem("timestamp");
    const jwtToken = localStorage.getItem("all3d_jwt_token");
    const isShopifyAuthorized = localStorage.getItem('shopify_authorized') === 'true';

    if (isShopifyAuthorized) {
      setLoading(false);
      return;
    }

    if (!shop || !hmac || !host || !timestamp) {
      console.error("Missing required Shopify params!");
      setLoading(false);
      return;
    }

    if (!jwtToken) {
      console.log("No portal user found — redirecting to login.");
      // Redirect to your portal login, passing shop so you can continue later
      localStorage.setItem('shop', shop);
      localStorage.setItem('hmac', hmac);
      localStorage.setItem('host', host);
      localStorage.setItem('timestamp', timestamp);
      window.top.location.href = `${ENVIRONMENT.PORTAL_LINK}?shop=${shop}`;
      setLoading(false);
      return;
    }

    // call install after they logged in
    axios
      .post(ENVIRONMENT.SHOPIFY_INSTALL, {
        shop,
        hmac,
        host,
        timestamp,
      })
      .then((res) => {
        console.log("BE response:", res.data);
        localStorage.removeItem('shop');
        localStorage.removeItem('hmac');
        localStorage.removeItem('host');
        localStorage.removeItem('timestamp', timestamp);
        setLoading(false);
        if (res.data.redirect_url) {
          window.top.location.href = res.data.redirect_url;
        } else {
          console.error("No redirect URL returned.");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error("Error:", err);
      });
  }, []);

  const isShopifyAuthorized = localStorage.getItem('shopify_authorized') === 'true';
  if (isShopifyAuthorized) {
    return <Welcome />;
  }

  return (
    <main style={{ textAlign: "center", padding: "2rem" }}>
      {loading ? (
        <>
          <div style={{ marginBottom: 16 }}>
            <Spin size="large" />
          </div>
          <h2>Redirecting to ALL3D...</h2>
        </>
      ) : (
        <h2>Redirecting to ALL3D...</h2>
      )}
    </main>
  );
}
